const initialState = {
    noData: false,
    locationsList: [],
    fetching: false,
    fetched: false,
    error: null
}

export function locationsReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_LOCATIONS_LIST_TOKEN":
        case "FETCH_LOCATIONS_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_LOCATIONS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_LOCATIONS_LIST_FULFILLED": {
            let publishedLocations = action.payload.data.filter(function (loc) {
                return loc.locationPagePublished == true
            })

            let unPublishedLocations = action.payload.data.filter(function (loc) {
                return loc.locationPagePublished == false
            })

            publishedLocations = publishedLocations.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase())
                    return -1
                else if (a.name.toLowerCase() > b.name.toLowerCase())
                    return 1
                else
                    return 0
            })

            unPublishedLocations = unPublishedLocations.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase())
                    return -1
                else if (a.name.toLowerCase() > b.name.toLowerCase())
                    return 1
                else
                    return 0
            })

            unPublishedLocations.forEach(function (loc) {
                publishedLocations.push(loc)
            })

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.length == 0, locationsList: publishedLocations }
        }
        case "FETCH_LOCATION_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
